import { create } from "zustand";

const useDeleteModal = create((set) => ({
	isOpen: false,
	onOpen: () => set({ isOpen: true }),
	onClose: () => set({ isOpen: false }),
	data: {},
}));

export default useDeleteModal;
